const ADS_ID = "AW-18527939901";
const SEND_TO = process.env.REACT_APP_GADS_SEND_TO;
const KEY = "dht_attribution";

const gtag = (...args) => { if (typeof window.gtag === "function") window.gtag(...args); };

export const trackPageView = (path) =>
  gtag("event", "page_view", { send_to: ADS_ID, page_path: path, page_location: window.location.href });

export const trackConversion = (role) => {
  gtag("event", "generate_lead", { send_to: ADS_ID, value: 1, currency: "USD", job_role: role });
  if (SEND_TO) gtag("event", "conversion", { send_to: SEND_TO, value: 1, currency: "USD" });
};

// Persist landing-page ad attribution so it survives navigation to the apply form.
export function captureAttribution() {
  const p = new URLSearchParams(window.location.search);
  const gclid = p.get("gclid");
  const source = p.get("utm_source") || (gclid ? "google" : "");
  if (!source) return;
  sessionStorage.setItem(KEY, JSON.stringify({
    utm_source: source,
    utm_medium: p.get("utm_medium") || (gclid ? "cpc" : ""),
    utm_campaign: p.get("utm_campaign") || "",
    gclid: gclid || "",
  }));
}

export const getAttribution = () => {
  try { return JSON.parse(sessionStorage.getItem(KEY) || "{}"); } catch { return {}; }
};
